import {createSlice} from "@reduxjs/toolkit";

export interface ISubscribeRealEstateStore {
    isModalOpen: boolean;
}

const initialState: ISubscribeRealEstateStore = {
    isModalOpen: false
};

export const subscribedRealEstatesSlice = createSlice({
    name: "subscribedRealEstates",
    initialState,
    reducers: {
        openModal: (state) => {
            state.isModalOpen = true;
        }
    }
});

export const {openModal} = subscribedRealEstatesSlice.actions;
